function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  opacity: 0.6,
  cx: 30.5,
  cy: 30.5,
  r: 29.5,
  stroke: "#181EA9"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.5 28.5L30 42 66.5 5.5",
  stroke: "#181EA9"
});

function SvgTxpass(props) {
  return React.createElement("svg", _extends({
    width: 67,
    height: 61,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjciIGhlaWdodD0iNjEiIHZpZXdCb3g9IjAgMCA2NyA2MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjYiIGN4PSIzMC41IiBjeT0iMzAuNSIgcj0iMjkuNSIgc3Ryb2tlPSIjMTgxRUE5Ii8+CjxwYXRoIGQ9Ik0xNi41IDI4LjVMMzAgNDJMNjYuNSA1LjUiIHN0cm9rZT0iIzE4MUVBOSIvPgo8L3N2Zz4K";
export { SvgTxpass as ReactComponent };